/**
 * Authentication Service
 */

import { getApiClient } from '../client';
import type {
  LoginRequest,
  LoginResponse,
  TokenRefreshRequest,
  TokenRefreshResponse,
  AuthStatus,
} from '../types';

export const authService = {
  /**
   * Complete OAuth PKCE flow with Spotify
   * @param request - Authorization code and PKCE verifier
   */
  async login(request: LoginRequest): Promise<LoginResponse> {
    return getApiClient().post<LoginResponse>('/auth/login', request);
  },

  /**
   * Refresh access token using refresh token
   * @param request - Refresh token
   */
  async refreshToken(request: TokenRefreshRequest): Promise<TokenRefreshResponse> {
    return getApiClient().post<TokenRefreshResponse>('/auth/refresh', request);
  },

  /**
   * Invalidate tokens and logout
   */
  async logout(): Promise<void> {
    return getApiClient().post<void>('/auth/logout');
  },

  /**
   * Check current authentication status
   */
  async getStatus(): Promise<AuthStatus> {
    return getApiClient().get<AuthStatus>('/auth/status');
  },
};
